import { AttributeModel } from "src/models";

export const checkIfAttributeIsDefault = (attribute: AttributeModel) =>
  attribute.kind === "default" || attribute.name === "productType";
